/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backend_Session_Error_CapacityInputs */

const en_backend_session_error_capacity = /** @type {(inputs: Backend_Session_Error_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service at capacity, no available compute right now.`)
};

const fr_backend_session_error_capacity = /** @type {(inputs: Backend_Session_Error_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service saturé, plus de capacité disponible pour le moment.`)
};

const ms_sg2_backend_session_error_capacity = /** @type {(inputs: Backend_Session_Error_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perkhidmatan penuh, tiada kapasiti tersedia ketika ini.`)
};

/**
* | output |
* | --- |
* | "Service at capacity, no available compute right now." |
*
* @param {Backend_Session_Error_CapacityInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_error_capacity = /** @type {((inputs?: Backend_Session_Error_CapacityInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_Error_CapacityInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_error_capacity(inputs)
	if (locale === "fr") return fr_backend_session_error_capacity(inputs)
	return ms_sg2_backend_session_error_capacity(inputs)
});